<div class="container">
    <div class="row me-landing-page-presentation" [class.block-revert]="data.alignMediaRight">
        <div class="col-md-6 col-xs-12">
            <div class="klenico-me__image">
                <img src="{{data.media.filename}}">
            </div>
        </div>
        <div class="col-md-6 col-xs-12">
            <div class="me-landing-page-presentation__sub_title">
                {{data.subHeadline}}
            </div>
            <div class="me-landing-page-presentation__title">
                {{data.headline}}
            </div>
            <div class="me-landing-page-presentation__description" [innerHTML]="data.description | storyblokRichtext">
            </div>
            <div class="me-landing-page-presentation__features" [innerHTML]="data.features | storyblokRichtext">
            </div>
            <div *ngIf="data.infoText && data.infoText != ''" class="me-landing-page-presentation__info">
                <i class="fal fa-info-circle icon"></i>
                <span>{{data.infoText}}</span>
            </div>
            <div class="me-landing-page-presentation__action">
                <storyblok-link [classList]="'btn btn--primary'" [data]="data.primaryCTA"></storyblok-link>
                <storyblok-link *ngIf="data.secondaryCTA && data.secondaryCTA.url != ''" [classList]="'btn btn--secondary'" [data]="data.secondaryCTA"></storyblok-link>
            </div>
        </div>
    </div>
</div>